import { documentId, limit, orderBy, query, startAfter, where } from "firebase/firestore";

export const LIST_PAGE_SIZE = 25;

// Count the same query population as paging, including orderBy's field-existence
// requirement, but never inherit the current page's cursor or limit.
export function buildListQueries(reference, { filters = [], order = [], cursor = null } = {}) {
  const constraints = filters.map(([field, operator, value]) => where(field, operator, value));
  const ordering = order.length ? order : [[documentId(), "asc"]];
  ordering.forEach(([field, direction]) => constraints.push(orderBy(field, direction)));
  const countQuery = query(reference, ...constraints);
  const pageConstraints = [...constraints];
  if (cursor) pageConstraints.push(startAfter(cursor));
  pageConstraints.push(limit(LIST_PAGE_SIZE));
  return { pageQuery: query(reference, ...pageConstraints), countQuery };
}

export function buildCrmLeadListQueries(reference, mode = "recent", cursor = null) {
  if (!["recent", "legacy"].includes(mode)) throw new Error("Unknown CRM page mode");
  return buildListQueries(reference, {
    order: mode === "recent"
      ? [["lastActivityAt", "desc"], [documentId(), "desc"]]
      : [[documentId(), "asc"]],
    cursor,
  });
}
